import { graphql, useStaticQuery } from 'gatsby';
import React from 'react';

import BasicText from '@ui/atoms/BasicText';

import CenteredGridItem from '@ui/molecules/CenteredGridItem';
import RoundedCard from '@ui/molecules/RoundedCard';

import { keysToCamel } from '@utils/butter';

import { useAuth } from '@providers/AuthProvider';

interface IBookingUnavailableProps {
	children: React.ReactNode;
}

interface IBookingUnavailableContent {
	unavailableMessage: string;
}

const BookingUnavailable = ({ children }: IBookingUnavailableProps) => {
	const { pageContent } = useStaticQuery(graphql`
		{
			pageContent: butterPage(slug: { eq: "booking-unavailable" }) {
				unavailable_message
			}
		}
	`);

	const { email: memberEmail } = useAuth();

	const { unavailableMessage }: IBookingUnavailableContent = keysToCamel(
		pageContent
	) as IBookingUnavailableContent;

	return (
		<>
			{process.env.GATSBY_BOOKING_UNAVAILABLE === 'true' &&
			!memberEmail.endsWith('@folxhealth.com') ? (
				<CenteredGridItem>
					<RoundedCard bgColor="cardRed">
						<BasicText>{unavailableMessage}</BasicText>
					</RoundedCard>
				</CenteredGridItem>
			) : (
				children
			)}
		</>
	);
};

export default BookingUnavailable;
